var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTaxandSmallIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 55,
  viewBox: "0 0 72 55",
  fill: "#222850",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.9605 13.9022C22.7468 13.9022 21 12.1875 21 9.95718C21 7.8789 22.7468 6.15088 24.9605 6.15088C27.0843 6.15088 28.8221 7.87913 28.8221 9.95718C28.8221 12.1875 27.0843 13.9022 24.9605 13.9022Z",
  fill: "#222850"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9605 26.2186C22.7468 26.2186 21 24.4991 21 22.2765C21 20.1817 22.7468 18.4671 24.9605 18.4671C27.0843 18.4671 28.8221 20.1817 28.8221 22.2765C28.8221 24.4991 27.0843 26.2186 24.9605 26.2186Z",
  fill: "#222850"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5383 20.1121C33.4259 20.1121 31.5085 18.3117 31.5085 16.1213C31.5085 14.0388 33.4259 12.1415 35.5383 12.1415C37.752 12.1415 39.5697 14.0385 39.5697 16.1213C39.5697 18.3117 37.752 20.1121 35.5383 20.1121Z",
  fill: "#222850"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5382 7.87893C33.423 7.87893 31.6731 6.15068 31.6731 3.93183C31.6731 1.83968 33.423 0 35.5382 0C37.7657 0 39.5115 1.83968 39.5115 3.93206C39.5115 6.15091 37.7654 7.87893 35.5382 7.87893Z",
  fill: "#222850"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5382 32.2551C33.423 32.2551 31.6731 30.5365 31.6731 28.3068C31.6731 26.2182 33.423 24.4991 35.5382 24.4991C37.7657 24.4991 39.5115 26.2186 39.5115 28.3068C39.5115 30.5367 37.7654 32.2551 35.5382 32.2551Z",
  fill: "#222850"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M46.2046 13.9022C44.0989 13.9022 42.3682 12.1875 42.3682 9.95718C42.3682 7.8789 44.0989 6.15088 46.2046 6.15088C48.4607 6.15088 50.204 7.87913 50.204 9.95718C50.2042 12.1875 48.4607 13.9022 46.2046 13.9022Z",
  fill: "#222850"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M46.2046 26.2186C44.0989 26.2186 42.3682 24.4991 42.3682 22.2765C42.3682 20.1817 44.0989 18.4671 46.2046 18.4671C48.4607 18.4671 50.204 20.1817 50.204 22.2765C50.2042 24.4991 48.4607 26.2186 46.2046 26.2186Z",
  fill: "#222850"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTaxandSmallIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TaxandSmallIcon.eeacb6a5.svg";
export { ForwardRef as ReactComponent };